import validarRedirecionamento from './redirecionamento.jsx'

/**
 * Mesmo contrato das notificações de cotação / serviço / mensagem:
 * o shell nativo repassa `navegar` na URL (?navegar=...) ou chama window.navegarPagina(chave).
 */
export function normalizarChaveNavegar(chave) {
	if (chave == null) return ''
	const txt = String(chave).trim()
	if (txt === '') return ''
	try {
		return decodeURIComponent(txt).trim()
	} catch {
		return txt
	}
}

export function lerNavegarQueryAtual() {
	const params = new URLSearchParams(window.location.search)
	if (!params.has('navegar')) return ''
	return normalizarChaveNavegar(params.get('navegar'))
}

const CHAVE_STORAGE_NAVEGAR_PENDENTE = 'mapp_navegar_pendente'
const TTL_NAVEGAR_PENDENTE_MS = 5 * 60 * 1000 // 5 minutos

/**
 * O nativo (Android) consome/zera o campo `navegar` assim que monta a 1ª URL do WebView.
 * Se o app recarregar por qualquer motivo (ex.: reloadPage() após token expirado/inválido)
 * antes do React concluir o redirecionamento (ou já dentro da tela de destino), o destino do
 * push se perde e cai no fallback padrão. Persistimos aqui — com expiração — para sobreviver
 * a esses reloads sem correr o risco de ficar "preso" redirecionando para sempre.
 */
export function salvarNavegarPendente(chave) {
	const valor = normalizarChaveNavegar(chave)
	if (!valor) return
	try {
		window.localStorage.setItem(
			CHAVE_STORAGE_NAVEGAR_PENDENTE,
			JSON.stringify({ chave: valor, ts: Date.now() })
		)
	} catch {
		// ignore (localStorage indisponível)
	}
}

export function lerNavegarPendente() {
	try {
		const raw = window.localStorage.getItem(CHAVE_STORAGE_NAVEGAR_PENDENTE)
		if (!raw) return ''
		const { chave, ts } = JSON.parse(raw)
		if (!chave || !ts || Date.now() - ts > TTL_NAVEGAR_PENDENTE_MS) {
			window.localStorage.removeItem(CHAVE_STORAGE_NAVEGAR_PENDENTE)
			return ''
		}
		return normalizarChaveNavegar(chave)
	} catch {
		return ''
	}
}

export function limparNavegarPendente() {
	try {
		window.localStorage.removeItem(CHAVE_STORAGE_NAVEGAR_PENDENTE)
	} catch {
		// ignore
	}
}

export function limparNavegarDaUrl() {
	try {
		const url = new URL(window.location.href)
		if (!url.searchParams.has('navegar')) return
		url.searchParams.delete('navegar')
		const qs = url.searchParams.toString()
		const destino = url.pathname + (qs ? `?${qs}` : '') + url.hash
		window.history.replaceState(window.history.state, '', destino)
	} catch {
		// ignore
	}
}

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {string} chaveRaw valor de navegar vindo do push
 * @param {{ state?: object }} [opts]
 * @returns {boolean} true se navegou para rota de push (não /home)
 */
export function navegarPorPush(navigate, chaveRaw, opts = {}) {
	const chave = normalizarChaveNavegar(chaveRaw)
	if (!chave) return false

	const rota = validarRedirecionamento(chave)
	if (!rota || rota === '/home') return false

	navigate(rota, {
		state: {
			viaNotificacao: true,
			navegarOrigem: chave,
			...(opts.state || {}),
		},
	})
	limparNavegarDaUrl()
	return true
}

/** iOS chama evaluateJS("navegarPagina('servico-cotacao')") — espelha validarRedirecionamento no React. */
export function registrarBridgeNavegarPagina(navigate) {
	window.navegarPagina = (chave) => {
		navegarPorPush(navigate, chave)
	}
}
